<app-header></app-header>
<section class="creation-form listdep" id="dependenceDetails">
  <div class="container-fluid">
    <div class="text-container">
      <div class="custom-container">
        <div class="backarrow">
          <h4><i (click)="goBack()" class="fa-solid fa-angle-left"></i>{{'Family Allowance List' | translate}}
          </h4>
        </div>
        <div class="dependants-buttons" *ngIf="currentUser==2 && userDetails.currently_active == 1 ">
          <a type="button" (click)="goToUrl()"><i class="fa-solid"><span>{{'Generate family allowance' | translate}}</span></i></a>
        </div>
      </div>
      <div class="head-2" *ngIf="currentUser==2 && userDetails.currently_active == 1 ">
        <p class="m-0">
          {{'You can only generate family allowances once a year. Please add all Dependents before Generating' | translate}}</p>
      </div>
    </div>
  </div>
</section>
<div class="initiale_sestion">
  <div class="legend">
    <div id="pending">
      <div class="circle"> </div>
      <h4 class="legend_txt">{{'Waiting for Employer submission'| translate}}</h4>
    </div>
    <div id="paynow">
      <div class="circle"> </div>
      <h4 class="legend_txt">{{'Waiting for admin Approval'| translate}}</h4>
    </div>
    <div id="rejected">
      <div class="circle"> </div>
      <h4 class="legend_txt">{{'Rejected'| translate}}</h4>
    </div>
    <div id="completed">
      <div class="circle"> </div>
      <h4 class="legend_txt">{{'Completed'| translate}}</h4>
    </div>
  </div>
</div>
<!-- 
<div class="status-container"
    [ngClass]="{ yellow1 : data.status == 0, red1 : data.status == 4, resubmitbg: data.status  == 5}"
    *ngIf="fragment != 1">
    <h6 *ngIf=" data.status == 0">{{'Pending' | translate}}</h6>
    <h6 *ngIf="data.status == 4">{{'Rejected' | translate}}</h6>
    <h6 *ngIf="data.status == 5">{{'Resubmitted' | translate}}</h6>
</div> -->
<section class="reportsList">
  <div class="mt-4">
    <div class="container-fluid reports_status mt-4 mb-5">
      <div class="card-grid" *ngFor="let item of allowanceData">
        <div class="child1">
          <div class="dflex">
            <div class="status" [ngClass]="{ completed1 : item.status == 1, yellow1 : item.status == 0, wesubmit : item.status == 8, wersubmit : item.status == 10, red1 : item.status == 4, resubmitbg: item.status  == 5}">
              <!-- <h6>{{item.type}} <i *ngIf="item.status==1" class="fa-solid fa-check"></i></h6> -->
              <h6 *ngIf=" item.status == 0">{{'Awaiting admin approval' | translate}}</h6>
              <h6 *ngIf="item.status == 4">{{'Rejected' | translate}}</h6>
              <h6 *ngIf="item.status == 5">{{'Resubmitted' | translate}}</h6>
              <h6 class="completed" *ngIf="item.status == 1">{{'Completed' | translate}} <i *ngIf="item.status==1" class="fa-solid fa-check"></i></h6>
              <h6 *ngIf="item.status == 8 || item.status == 10">{{'Awaiting employer submit' | translate}}</h6>
            </div>
            <div class="columns">
              <!-- <h3 class="sub-title">{{item.company_id}}</h3> -->
              <h6 class="sm_text">{{'First Name'| translate}} : <span> {{item.first_name}}</span></h6>
              <h6 class="sm_text">{{'Last Name'| translate}} : <span> {{item.last_name}}</span></h6>
              <h6 class="sm_text">{{'Mother name'| translate}} : <span>{{item.mother_name}}</span></h6>
            </div>
          </div>
        </div>
        <div class="child2">
          <div class="columns">
            <h6 class="sm_text">{{'Maiden Name'| translate}} : <span> {{item.maiden_name}} <span *ngIf="!item.maiden_name">--</span></span></h6>
            <h6 class="sm_text">{{'Father name'| translate}} : <span>{{item.father_name}}</span></h6>
            <h6 class="sm_text">{{'Email'| translate}} : <span> {{item.email}} </span></h6>
          </div>
        </div>
        <div class="child3">
          <div class="columns">
            <h6 class="sm_text">{{'Post box'| translate}} : <span>{{item.postbox}}</span></h6>
            <h6 class="sm_text">{{'Phone'| translate}} : <span>+241 {{item.phone}} </span></h6>
            <h6 class="sm_text">{{'Date of Birth'| translate}} : <span>{{item.dob}}</span></h6>
          </div>
        </div>
        <div class="child4">
          <button *ngIf="item && item.status!==4 && currentUser==2 || item.status==8 || item.status==0 || item.status== 4 && currentUser==1 || item.status==10 && currentUser==1 || item.status==5 && currentUser==1 || item.status==1 && currentUser==1" (click)="getViewAllowanceReports(item.allowance_id)" id="submit_btn" class="btn btn-main2"><a>{{'View'| translate}} <br> {{'Details'|
              translate}}</a></button>
          <button (click)="goToResubmit(item.allowance_id)" *ngIf="item && item.status==4 && currentUser==2 " id="submit_btn" class="btn btn-main2"><a>{{'Resubmit'|
              translate}}</a></button>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="creation-form listdep" id="dependenceDetails" *ngIf="allowanceData && allowanceData.length == 0">
  <div class="container-fluid">
    <div class="list-card">
      <div id="employee-nolist">
        <div class="image-container col-sm-12">
          <img src="assets/images/employee_nolist.png">
        </div>
        <div class="text-container text-center">
          <h3>{{'No family allowance Added yet' | translate}}</h3>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
